<template>
  <el-form :inline="true" :model="filterForm" class="" size="mini">
    <el-form-item :label="assetTypeLabel">
      <el-select v-model="filterForm.AssetType" style="width: 180px" @change="onAssetTypeChange">
        <el-option
          v-for="item in resourceTypeOption"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="版本号">
      <el-select v-model="filterForm.Versions" style="width: 180px" @change="onVersionChange">
        <el-option
          v-for="item in versionOption"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="日期">
      <el-select v-model="filterForm.ScanTime" style="width: 180px">
        <el-option
          v-for="item in dateOption"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="数据">
      <el-select v-model="filterForm.isComplete" style="width: 120px">
        <el-option
          v-for="item in dataOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="展示字段">
      <el-select
        v-model="filterForm.showField"
        style="width: 180px"
        collapse-tags
        multiple
      >
        <el-option
          v-for="item in showFieldOption"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
      <el-button type="primary" class="ms-1" @click="showDialogThreshold">阈值与区间设置</el-button>
    </el-form-item>

    <el-form-item label="图表">
      <el-select v-model="filterForm.chartType" style="width: 180px">
        <el-option label="直方图" value="bar" />
        <el-option label="饼状图" value="pie" />
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="$emit('ensure', filterForm)">确定</el-button>
    </el-form-item>
  </el-form>

  <dialog-threshold ref="dialogThreshold" :AssetType="filterForm.AssetType" :showFieldOption="showFieldOption" @confirm="$emit('threshold-submited', filterForm)" />
</template>

<script>
import { ref, onMounted, nextTick, inject, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import DialogThreshold from "./dialog-threshold.vue";

function copy(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export default {
  components: {DialogThreshold},
  emits: ['ensure', 'threshold-submited'],
  props: {
    pageType: String,
    resourceType: Number,
    assetTypeLabel: {
      type: String,
      default: '资源类型'
    },
  },

  setup(props) {
    let dialogThreshold = ref(null);
    let route = useRoute(),
      project = route.query.project,
      filterForm = ref({
        showField: [],
        chartType: 'bar',
        isComplete: false,
      }),
      versionOption = ref([]),
      dateOption = ref([]),
      resourceTypeOption = ref([]),
      versionToDate = {},
      assetToField = ref([]),
      showFieldOption = ref([]),
      dataOption = [
        {label: '全量', value: true},
        {label: '增量', value: false},
      ]

      async function getFilterOptions() {
        const {data} = await axios(`memory/static_field_list/?project=${project}`)
        resourceTypeOption.value = Object.keys(data)
        filterForm.value.AssetType = resourceTypeOption.value[0]
        assetToField.value = data

        await onAssetTypeChange()

        return {
          formData: filterForm.value
        }
      }

      async function onVersionChange() {
        dateOption.value = versionToDate[filterForm.value.Versions]
        filterForm.value.ScanTime = dateOption.value[0]
      }

      function getVersions(versions) {
        const arr = Object.keys(versions).map(version => ({date: versions[version][0], version}))
        arr.sort((a, b) => new Date(b.date) - new Date(a.date))
        return arr.map(item => item.version)
      }

      async function onAssetTypeChange() {
        const {data} = await axios(`memory/static_version_list/?project=${project}&static_type=${filterForm.value.AssetType}`)
        versionOption.value = getVersions(data.versions)
        filterForm.value.Versions = versionOption.value[0]
        versionToDate = data.versions
        dateOption.value = versionToDate[filterForm.value.Versions]
        filterForm.value.ScanTime = dateOption.value[0]

        showFieldOption.value = assetToField.value[filterForm.value.AssetType]
        filterForm.value.showField = copy(showFieldOption.value)
      }

      function showDialogThreshold() {
        dialogThreshold.value.open();
      }

    return {
      dataOption,
      showFieldOption,
      dialogThreshold, 
      dateOption,
      versionOption,
      resourceTypeOption,
      filterForm,
      getFilterOptions,
      onVersionChange,
      showDialogThreshold,
      onAssetTypeChange
    }
  }
}
</script>